export default (() => {
    $('input.number').each(function() {
        $(this).wrap('<div class="number-wrapper"></div>');
        $(this).parent().append('<i class="fal fa-plus increment"></i><i class="fal fa-minus decrement"></i>');
    })

    $.fn.inputFilter = function(inputFilter) {
        return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
        });
    };

    $('input.number').each(function(){
        if(!$(this).val()) {
            $(this).val(0);
        }
    });

    $('input.number').inputFilter(function(value) {
        return /^\d*$/.test(value);
    });

    $('.number-wrapper .increment').click(function() {
        $(this).parent().find('input').val(+$(this).parent().find('input').val() + 1);
    })

    $('.number-wrapper .decrement').click(function() {
        if($(this).parent().find('input').val() <= 0) {
            return;
        }

        $(this).parent().find('input').val(+$(this).parent().find('input').val() - 1);
    })

    $('body').on('DOMNodeInserted', '.drp-calendar', function() {
        $('.drp-calendar .month').each(function() {
            $(this).siblings(':last').addClass('next available');
        })
    });

    $('.single-date-picker').focus(function() {

        var dropdown = $(this).hasClass('dropdown') ? true : false;

        $(this)
        .daterangepicker({
                            autoApply: true,
                            showDropdowns: dropdown,
                            singleDatePicker: true,
                            opens: 'center',
                            locale: {
                              format: 'DD/MM/YYYY',
                              'daysOfWeek': [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                            ],
                            'monthNames': [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                            ],
                            firstDay: 1,
                          },
                        })
    })

    $('.future-date-picker').focus(function() {

        var dropdown = $(this).hasClass('dropdown') ? true : false;

        $(this)
        .daterangepicker({
                            autoApply: true,
                            showDropdowns: dropdown,
                            singleDatePicker: true,
                            opens: 'center',
                            minDate: new Date(),
                            locale: {
                              format: 'DD/MM/YYYY',
                              'daysOfWeek': [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                            ],
                            'monthNames': [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                            ],
                            firstDay: 1,
                          },
                        })
    })
    
    $('select').each(function() {
        if($(this).parent('.woocommerce-input-wrapper').length) {
            $(this).parent('.woocommerce-input-wrapper').wrapAll('<div class="select-wrapper"></div>');
            return;
        }

        $(this).wrap('<div class="select-wrapper"></div>');
    })

    $('input[type=file]:not(.upload-competition-photo)').each(function() {
        $(this).wrap('<label class="file-wrapper"></label>');
        $(this).parents('.file-wrapper').append('<span>Submit Resume +</span>');
    })

    $('input[type=file]').click(function(e) {
        if($(this).val()) {
            e.preventDefault();

            $(this).val('');

            $(this).siblings('span').show();
            $(this).siblings('.file').hide();
        }
    })

    $('input[type=file]:not(.upload-competition-photo)').change(function() {
        $(this).siblings('span').hide();
        $(this).parents('.file-wrapper').append(`<div class="file"><p>${$(this)[0].files.item(0).name} <i class="fas fa-times"></i></p></div>`);
    });
	
	
	// Photography Competition
	$('input[type=file].upload-competition-photo').each(function() {
        $(this).wrap('<label class="file-input"></label>');
        $(this).parents('.file-input').append('<span>Upload a File</span>');
    })
	
    $('input[type=file].upload-competition-photo').change(function() {
        $(this).siblings('span').hide();
        $(this).parents('.file-input').append(`<div class="file"><p>${$(this)[0].files.item(0).name} <i class="fas fa-times"></i></p></div>`);
    });

    $(document).ready(function() {
        document.addEventListener( 'wpcf7mailsent', function() {
            $('.download-brochure .wpcf7').addClass('hide');
            $('.download-brochure .download-btn').removeClass('hide');
        }, false );
    })
});



// WEBPACK FOOTER //
// ./scripts/components/forms.js